<template>
  <div id="app">
    <!-- <pre>{{ records }}</pre> -->
    <!-- <p>Total records fetched: {{ records.length }}</p> -->
    <!-- Search Bar -->
    <div class="field">
      <div class="control has-icons-left mb-5">
        <input v-model="searchInput" class="input is-large" type="text" placeholder="Search by organization name" @input="filterRecords">
        <span class="icon is-small is-left">
          <i class="fas fa-search"></i>
        </span>
      </div>
    </div>
    <div class="buttons has-addons is-centered">
      <button @click="clearFilters" :class="{ 'button': true, 'is-active': areAllFiltersInactive }">All</button>
      <button @click="toggleFilter('investorGroup')" :class="{ 'button': true, 'is-active': filters.investorGroup }">Investors</button>            
      <button @click="toggleFilter('supportingOrganization')" :class="{ 'button': true, 'is-active': filters.supportingOrganization }">Incubator/Accelerator</button>     
    </div>
    <!-- <div class="buttons is-centered">
      <button class="button is-small" @click="selectRegion('')">All</button>
      <button v-for="region in uniqueRegions" :key="region" class="button is-small" @click="selectRegion(region)" :class="{ 'is-active': region === selectedRegion }">
        {{ region }}
      </button>
    </div> -->
    
    <!-- Display "No results" message if there are no filtered records -->
    <div v-if="filteredRecords.length === 0">
      <p class="is-size-1 has-text-centered">No results</p>
    </div>
    <!-- Display the count of filtered records -->
    <!-- <p v-if="filteredRecords.length > 0" class="has-text-centered mb-3 is-italic">
      Search Results: {{ filteredRecords.length }}
    </p> -->

    <!-- Display the filtered records -->
    <div v-else>
      <!-- Display the filtered records -->
    </div>
    <!-- Cards -->
    <section class="mr-5 ml-5">
      <div class="columns is-multiline">
        <div class="column is-one-third card-column" v-for="record in filteredRecords" :key="record.id">
          <a :href="getWebsiteUrl(record)" target="_blank" class="card card-link"> <!-- Wrap the card with an <a> tag -->
            <div class="card-image">
              <figure class="image has-text-centered pt-5">
                <div class="centered-image">
                  <img :src="getLogoUrl(record).url" :height="getLogoUrl(record).height" alt="Logo" class="fixed-height-image">
                </div>
              </figure>
            </div>
            <div class="card-content has-text-centered">
              <p class="title is-size-5 has-text-weight-bold">{{ record.fields.Company }}</p>
              <!-- <div class="tags is-centered">
                <span class="tag is-warning" v-if="record.fields['Innovation / Entrepreneurship Hub']">Innovation Hub</span>
                <span class="tag is-primary" v-if="record.fields['VC / PE']">Investor</span>              
                <span class="tag is-primary" v-if="record.fields['Angel Group']">Investor</span>
                <span class="tag is-primary" v-if="record.fields['Individual Angel']">Individual Angel</span>
                <span class="tag is-info" v-if="record.fields['Accelerator / Incubator']">Accelerator / Incubator</span>
                <span class="tag is-primary" v-if="record.fields['Government']">Government</span>
                <span class="tag is-warning" v-if="record.fields['Academic']">Academic</span>
                <span class="tag is-danger" v-if="record.fields['Consultant']">Consultant</span>                
                <span class="tag is-light">{{ record.fields['RDA Region'].join(', ') }}</span>
              </div> -->
            </div>
          </a>
        </div>
      </div>
    </section>
    <!-- Conditional rendering of ErrorMessage component -->
    <ErrorMessage v-if="isAppBroken" image-src="https://cdn.dribbble.com/users/124059/screenshots/15231994/dribbble.png?resize=400x0" error-message="Sorry, we are making some upgrades right now, come back soon!" />
  </div>
</template>

<script>
import axios from 'axios';
import fuzzysort from 'fuzzysort';
import ErrorMessage from './components/ErrorMessage.vue';

export default {
  name: 'App',
  components: {
    ErrorMessage
  },
  data() {
    return {
      isAppBroken: false,      
      searchInput: '',
      records: [],
      filteredRecords: [],
      filters: {
        paidMember: false,
        networkMember: false,
        womensInitiative: false,
        angelGroup: false,
        acceleratorIncubator: false,
        innovationHub: false,
        nonProfit: false,
        vcPE: false,
        government: false,
        academic: false,
        consultant: false,
        supportingOrganization: false, // New filter for Supporting Organization
      }
    };
  },
  computed: {
    uniqueRegions() {
      const regionOrder = {
        'Northern Canada': 1,
        'Western': 2,
        'Prairies': 3,
        'Northern Ontario': 4,
        'Southern Ontario': 5,
        'Quebec': 6,
        'Atlantic': 7
      };

      const regions = this.records.flatMap(record => record.fields['RDA Region'] || []);

      const uniqueSortedRegions = [...new Set(regions)].sort((a, b) => {
        const orderA = regionOrder[a] || Infinity;
        const orderB = regionOrder[b] || Infinity;
        return orderA - orderB;
      });

      return uniqueSortedRegions;
    },
    getLogoUrl() {
      return (record) => {
        const logoField = record.fields.Logo;
        if (logoField && Array.isArray(logoField) && logoField.length > 0 && logoField[0].thumbnails && logoField[0].thumbnails.large) {
          const thumbnail = logoField[0].thumbnails.large;
          return {
            url: thumbnail.url,
            width: thumbnail.width,
            height: thumbnail.height
          };
        }
        return {
          url: 'https://cdn.onlinewebfonts.com/svg/img_546302.png', // Placeholder image URL
          width: 0,
          height: 0
        };
      };
    },
    areAllFiltersInactive() {
    return Object.values(this.filters).every(filter => !filter);
  },
  },
  methods: {
    filterRecords() {
      const searchTerm = this.searchInput.toLowerCase();

      this.filteredRecords = this.records.filter(record => {
        const company = record.fields.Company.toLowerCase();

        // Apply search filter only if search term is provided
        if (searchTerm) {
          const result = fuzzysort.single(searchTerm, company);
          return result && result.score > -Infinity;
        }

        // Apply all other filters
        return (
          // Existing filters
          (!this.filters.paidMember || record.fields['Paid Member']) &&
          (!this.filters.networkMember || record.fields['Network Member']) &&
          (!this.filters.womensInitiative || record.fields["Women's Initiative Partners"]) &&
          (!this.filters.angelGroup || record.fields["Angel Group"] || record.fields["Individual Angel"]) &&
          (!this.filters.acceleratorIncubator || record.fields['Accelerator / Incubator']) &&
          // New filters
          (!this.filters.supportingOrganization || 
            (
              !record.fields['VC / PE'] &&
              !record.fields['Angel Group']
            )
          ) &&
          (!this.filters.investorGroup || (record.fields['Angel Group'] || record.fields['VC / PE'])) &&
          (!this.filters.innovationHub || record.fields['Innovation / Entrepreneurship Hub']) &&
          (!this.filters.vcPE || record.fields['VC / PE']) &&
          (!this.filters.government || record.fields['Government']) &&
          (!this.filters.academic || record.fields['Academic']) &&
          (!this.filters.nonProfit || record.fields['Not-for Profit']) &&
          (!this.filters.consultant || record.fields['Consultant']) &&
          // RDA Region filter
          (this.selectedRegion === '' || (record.fields['RDA Region'] && record.fields['RDA Region'].includes(this.selectedRegion)))
        );
      });

      // Sort the filtered records in alphabetical order by company name
      this.filteredRecords.sort((a, b) => a.fields.Company.localeCompare(b.fields.Company));
    },

    selectRegion(region) {
      this.selectedRegion = region;
      this.filterRecords(); // Reapply filters when a region is selected
    },

    getWebsiteUrl(record) {
      let url = record.fields['Organization Website'];
      if (url && !url.startsWith('http://') && !url.startsWith('https://')) {
        url = 'https://' + url;
      }
      return url;
    },
    toggleFilter(filter) {
    // Disable all filters
      Object.keys(this.filters).forEach(key => {
        this.filters[key] = false;
      });

      // Enable the selected filter
      this.filters[filter] = true;

      this.filterRecords(); // Reapply filters when a filter is toggled
    },
    clearFilters() {
      // Reset all filters to false
      Object.keys(this.filters).forEach(key => {
        this.filters[key] = false;
      });

      // Clear the search input
      this.searchInput = '';

      // Apply filters
      this.filterRecords();
    },

  },
  watch: {
    searchInput() {
      this.filterRecords();
    },
    filters: {
      handler() {
        this.filterRecords();
      },
      deep: true
    }
  },
  async created() {
    let offset = null;
    const fields = [
      'Company',
      'Organization%20Website',
      'RDA%20Region',
      'Paid%20Member',
      'Network%20Member',
      'Women\'s%20Initiative%20Partners',
      'Angel%20Group',
      'Individual%20Angel',
      'Accelerator%20/%20Incubator',
      'Logo',
      'VC%20/%20PE',
      'Government',
      'Academic',
      'Consultant',
      'Innovation%20/%20Entrepreneurship%20Hub',
      'Not-for%20Profit',
    ];
    do {
      const response = await axios.get(
        'https://api.airtable.com/v0/appy8YDtPlliX4pxr/Master Contact List?filterByFormula=OR(%7BPaid Member%7D = TRUE(), %7BNetwork Member%7D = TRUE())' +
        fields.map(field => '&fields[]=' + field).join('') +
        (offset ? '&offset=' + offset : ''),
        {
          headers: {
            'Authorization': 'Bearer keycMRh2eQudolEOB',
            'Content-Type': 'application/json'
          }
        }
      );
      this.records = [...this.records, ...response.data.records.filter(record => !record.fields['Individual Angel'])];
      offset = response.data.offset;
    } while (offset);
    this.filteredRecords = this.records;
    this.selectedRegion = ''; // Set the default selected region to "All"
    this.filterRecords(); // Apply filters on component initialization
  },
};
</script>


<style scoped>
.buttons {
  margin-bottom: 10px;
}

.buttons .button {
  margin-right: 5px;
}

.buttons .is-active {
  background-color: #0ebff1;
  color: #fff;
}

.fixed-height-image {
  height: 50px; /* Adjust the height to your desired fixed value */
  width: auto; /* Allow the width to adjust proportionally */
}
.centered-image {
  display: inline-block;
}

.card-link {
  display: block;
  border-radius: 6px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.3s ease;
  background-color: #fff;
}

.card-link:hover {
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.card-link .card-content {
  padding: 1.5rem;
}

.card-link .card-content p.title {
  margin-bottom: 0.75rem;
}

.card-link .tags {
  margin-top: 0.75rem;
}

.card-link .tags .tag {
  margin-bottom: 0.25rem;
}

</style>